import useCoreEnums from 'src/api/core/core-enums/useCoreEnums';
import type { ConfigRendererProps } from './types';
import { useRegisterDynamicRefresh } from './useRegisterDynamicRefresh';
import type { InlineCategory } from './ClassificationCategoryFields';

export function readClassificationFields(config: Record<string, unknown>) {
  const confidenceThreshold = config.confidenceThreshold;
  return {
    classificationSource: (config.classificationSource as string) || 'inline',
    coreEnumId: (config.coreEnumId as string) || '',
    categories: (config.categories as InlineCategory[]) || [],
    allowedFileExtensions: (config.allowedFileExtensions as string[]) || [],
    confidenceThreshold:
      typeof confidenceThreshold === 'number' ? confidenceThreshold : 0.5,
    includeOther: config.includeOther !== false,
    classificationRules: (config.classificationRules as string) || '',
    baseProcessor: (config.baseProcessor as string) || '',
  };
}

export function useClassificationConfig(
  config: Record<string, unknown>,
  onConfigChange: ConfigRendererProps['onConfigChange'],
  registerDynamicRefresh?: ConfigRendererProps['registerDynamicRefresh'],
) {
  useRegisterDynamicRefresh(registerDynamicRefresh, [['core/core-enums']]);
  const fields = readClassificationFields(config);

  const { data: enumsResponse } = useCoreEnums(
    { first: 100, includeOptions: true },
    { staleTime: 30_000 },
  );
  const enums = enumsResponse?.edges ?? [];
  const selectedEnum = fields.coreEnumId
    ? enums.find((entry) => entry.id === fields.coreEnumId)
    : undefined;

  const update = (updates: Record<string, unknown>) => {
    void onConfigChange({ ...config, ...updates });
  };

  return {
    ...fields,
    enums,
    selectedEnum,
    update,
  };
}
